exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".controlButtons.lang-level-pill .controlBarButton.vjs-button.language{border-radius:10px 0 0 10px;border-right:none}.controlButtons.lang-level-pill .controlBarButton.vjs-button.language .text{overflow:hidden}\n", ""]);

